import React from "react";

function DTOGoals() {
  return <></>;
}
export default DTOGoals;
